import { DocumentStages } from '../../graphql/generated/types';

export const documentStageLabels = {
  [DocumentStages.Simulation]: 'Cotação',
  [DocumentStages.Quotation]: 'Cotação',
  [DocumentStages.Proposal]: 'Proposta',
  [DocumentStages.Policy]: 'Apólice',
};
